import { render, staticRenderFns } from "./TransactionResultModal.vue?vue&type=template&id=47321b62&scoped=true&"
import script from "./TransactionResultModal.vue?vue&type=script&lang=js&"
export * from "./TransactionResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47321b62",
  null
  
)

export default component.exports